import React from 'react';

/**
 * Renders structured legal document blocks from locale JSON (termsWebsite / privacyWebsite).
 */
export function LegalBlocks({ blocks, ui }) {
  if (!Array.isArray(blocks)) return null;
  const { P, List, Li, Subtitle, ContactBlock, Table, Th, Td } = ui;

  return blocks.map((b, idx) => {
    switch (b.type) {
      case 'p':
        return <P key={idx}>{b.text}</P>;
      case 'pStrong':
        return (
          <P key={idx}>
            <strong>{b.strong}</strong>
            {b.rest || ''}
          </P>
        );
      case 'h3':
        return <Subtitle key={idx}>{b.text}</Subtitle>;
      case 'ul':
        return (
          <List key={idx}>
            {(b.items || []).map((item, i) => (
              <Li key={i}>{item}</Li>
            ))}
          </List>
        );
      case 'contact':
        return <ContactBlock key={idx}>{b.text}</ContactBlock>;
      case 'table':
        if (!Table || !Th || !Td) return null;
        return (
          <Table key={idx}>
            <thead>
              <tr>
                {(b.headers || []).map((h, i) => (
                  <Th key={i}>{h}</Th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(b.rows || []).map((row, ri) => (
                <tr key={ri}>
                  {row.map((cell, ci) => (
                    <Td key={ci}>{cell}</Td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        );
      default:
        return null;
    }
  });
}
